import { useEffect, useState } from 'react';
import api from '../api';
import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function Counterparties() {
  const { currentCompany } = useApp();
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({
    name: '', type: 'company', country: 'PL', nip: '', address: '', email: '', phone: '', notes: '',
  });

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const { data } = await api.get('/counterparties');
      setItems(data || []);
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || t('common.error'));
    }
  }

  async function create() {
    if (!currentCompany?.id) { setMsg(t('counterparties.select_company')); return; }
    if (!form.name) { setMsg(t('counterparties.enter_name')); return; }
    try {
      await api.post('/counterparties', { ...form, company_id: currentCompany.id });
      setForm({ name: '', type: 'company', country: 'PL', nip: '', address: '', email: '', phone: '', notes: '' });
      setMsg('✅ ' + t('counterparties.added'));
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || t('common.error'));
    }
  }

  async function remove(id) {
    if (!confirm(t('counterparties.confirm_delete'))) return;
    try {
      await api.delete(`/counterparties/${id}`);
      setMsg('🗑 ' + t('counterparties.deleted'));
      load();
    } catch (e) {
      setMsg(e.userMessage || e.response?.data?.detail || t('common.error'));
    }
  }

  return (
    <div className="page">
      <BackButton />
      <h1>🤝 {t('counterparties.title')}</h1>
      {msg && <div className="message">{msg}</div>}

      <div style={{ background: 'var(--card)', borderRadius: 16, padding: 18, marginBottom: 16, border: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ fontWeight: 700, marginBottom: 10 }}>➕ {t('counterparties.new')}</div>
        <div className="form">
          <div className="field">
            <label>{t('counterparties.name_label')}</label>
            <input placeholder={t('counterparties.name_label')} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div className="field" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label>{t('counterparties.type_label')}</label>
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                <option value="company">{t('counterparties.type_company')}</option>
                <option value="person">{t('counterparties.type_person')}</option>
              </select>
            </div>
            <div>
              <label>{t('counterparties.country_label')}</label>
              <input placeholder="PL/UA/DE..." value={form.country} onChange={e => setForm({ ...form, country: e.target.value.toUpperCase() })} />
            </div>
          </div>
          <div className="field">
            <label>{t('counterparties.nip_vat')}</label>
            <input placeholder="NIP/VAT" value={form.nip} onChange={e => setForm({ ...form, nip: e.target.value })} />
          </div>
          <div className="field">
            <label>{t('counterparties.address_label')}</label>
            <input placeholder={t('counterparties.address_label')} value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
          </div>
          <div className="field" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label>{t('counterparties.email_label')}</label>
              <input placeholder="name@email.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <label>{t('counterparties.phone_label')}</label>
              <input placeholder="+48 ..." value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
            </div>
          </div>
          <div className="field">
            <label>{t('counterparties.notes_label')}</label>
            <textarea placeholder={t('counterparties.notes_label')} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
          </div>
        </div>
        <button className="btn btn-primary" style={{ width: '100%' }} onClick={create}>{t('common.save')}</button>
      </div>

      {items.length === 0 ? (
        <div className="empty">{t('counterparties.no_counterparties')}</div>
      ) : (
        <div className="list">
          {items.map(c => (
            <div key={c.id} className="list-item" style={{ alignItems: 'flex-start' }}>
              <div className="list-main">
                <div className="list-title">{c.name}</div>
                <div className="list-sub">{c.country} • {c.type}</div>
                {c.email && <div className="list-sub">Email: {c.email}</div>}
                {c.address && <div className="list-sub">{t('counterparties.address_label')}: {c.address}</div>}
              </div>
              <button className="btn btn-small" style={{ background: 'rgba(239,68,68,0.3)' }} onClick={() => remove(c.id)}>🗑</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
